const file = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="m10.5 0 .004.004h.293L15 4.205V16H1V.007l9.5-.003zM9 1.518l-6.5.055v12.928h11V6.004H9zm3 9.484v1.5H4v-1.5zm0-2.999v1.5H4v-1.5zm-1.5-6.176v2.678h2.68z"/></svg>',
};

export { file as default };
